import type { Category } from "../../types";

interface Props {
  category?: Category | null;
}

export function CategoryBadge({ category }: Props) {
  if (!category) {
    return (
      <span style={{ background: "#334155", color: "#94a3b8", borderRadius: "4px", padding: "2px 8px", fontSize: "0.75rem" }}>
        Uncategorised
      </span>
    );
  }
  return (
    <span style={{
      background: category.color + "33",
      color: category.color,
      border: `1px solid ${category.color}55`,
      borderRadius: "4px",
      padding: "2px 8px",
      fontSize: "0.75rem",
      fontWeight: 500,
    }}>
      {category.name}
    </span>
  );
}
